/**
  variables declared in snippets/digitalcubed-gtm-head.liquid:
  d3Cart, d3CartProducts, d3TemplateName, d3PageType, d3Product, d3Variant, d3Customer, d3Search, d3Geolocation
 **/
  var d3jqueryLoaded = false;

  /* 
   * this is the first function that runs
   */
  function d3DomLoaded() {
    /* 
     * anything NOT dependent on jQuery can go here 
     */
    //window.console.log('digitalcubed-gtm.js d3DomLoaded');
    
    d3ViewPage();
    d3ImpressionsManager.startListener();
  
    switch (d3TemplateName) {
      case 'cart':
        d3ViewCart();
        break;
      case 'product':
        d3ViewPDP();
        break;
      default:
        // nothing
        break;
    }
  
    /***
    bind handler for theme:cart:jsloaded
    ***/  
    window.on('theme:cart:jsloaded', ({ detail: data }) => {      
      //window.console.log('theme:cart:jsloaded', data);
      d3Cart = data;
      d3CartUpdated();
    });
  
    /***
    bind handler for theme:cart:productAdded
    ***/  
    window.on('theme:cart:productAdded', ({ detail: data }) => {      
      //window.console.log('theme:cart:productAdded', data);
      var variantId = data.e;
      let params = new URLSearchParams(data.t.body);
      var quantity = params.get("quantity");
      var productId = params.get("product-id");
      var sectionId = params.get("section-id");
      if (sectionId == 'product--quick-add--form') {
        d3AddToCartQuickAdd(variantId, quantity, productId);
      } else {
        d3AddToCartPDP(variantId, quantity, productId, sectionId);
      }
    });
  
    /***
    bind handler for theme:cart:quantityUpdated (includes qty +/- and remove from cart)
    ***/  
    window.on('theme:cart:quantityUpdated', ({ detail: data }) => {      
      window.console.log('theme:cart:quantityUpdated', data);
      if (data.items_removed && data.items_removed.length) {      
        data.items_removed.forEach(t => d3RemoveFromCart(t));
  
        // if an item was removed and the cart becomes empty
        if (data.item_count == 0) {
          d3CartEmpty();
        }
      }
    });
    
    /***
    bind handler for klaviyoForms submit
    ***/  
    d3OnKlaviyoSubmit();
  
    
    var checkJquery = function(){ if (typeof jQuery === "undefined"){ return false; } else { clearTimeout(jqInterval); d3jQueryReady(); }}
    var jqInterval = setInterval(checkJquery,200);
  
    //    geolocation: orbito.orbeSession.geolocation
    var checkOrbe = function(){ if (typeof orbito === "undefined" || typeof orbito['orbeSession'] === "undefined" || typeof orbito['orbeSession']['geolocation'] === "undefined"){ return false; } else { clearTimeout(orbeInterval); orbeLoaded(); }}
    var orbeInterval = setInterval(checkOrbe,200);
    
  } // end d3DomLoaded
  
  
  /* this is like $(document).ready() */
  var d3jQueryReady = function() {
    /*
     * anything dependent on jQuery can go in here 
     */
    //window.console.log('digitalcubed-gtm.js d3jQueryReady');
    d3jqueryLoaded = true;
    
    d3ImpressionsManager.startTimer();
  
    d3OnCreateAccount();
    d3OnEmailSignup();  
  
  } // end d3jQueryReady
  
  /* 
   * when Orbe geolocation is loaded
   */
  var orbeLoaded = function () {
    //window.console.log('orbe', orbito.orbeSession.geolocation);
    // save some of the properties locally for later use
    d3Geolocation = {
      city: orbito.orbeSession.geolocation.city,
      countryName: orbito.orbeSession.geolocation.country,
      countryCode: orbito.orbeSession.geolocation.countryCode,
      regionCode: orbito.orbeSession.geolocation.region,
      regionName: orbito.orbeSession.geolocation.regionName,
      postalCode: orbito.orbeSession.geolocation.zip
    };
    // send to the dataLayer
    var gtmEvent = {
      event: "geolocation",
      geolocation: d3Geolocation
    };
  
    //window.console.log("geolocation gtm data=", gtmEvent);
    window.dataLayer.push(gtmEvent);
  } // end orbeLoaded
  
  
  /************
   ResumableInterval - timer function that can pause & resume
  *************/
  function ResumableInterval(e,n){let t,l=!1,r=()=>{l||(t=setInterval(e,n))},u=()=>{clearInterval(t),l=!0},a=()=>{l&&(t=setInterval(e,n),l=!1)},_=()=>{clearInterval(t)};return{start:r,pause:u,resume:a,stop:_}}
  
  
  /************
    custom async function to hash private info
  *************/
  const getSha256Hash = val => window.crypto.subtle
      .digest('SHA-256', new TextEncoder('utf-8').encode(val))
      .then(h => {
          let hexes = [],
              view = new DataView(h);
          for (let i = 0; i < view.byteLength; i+=4) {
              hexes.push(('00000000' + view.getUint32(i).toString(16)).slice(-8));
          }
          return hexes.join('');
      });
  
  /************ 
    send "view_page" event to GTM 
  *************/
  function d3ViewPage() {
    //window.console.log("d3ViewPage");
    
    var gtmEvent = {
      event: "view_page",
      page_type: d3PageType,
      user_type: d3Customer.user_type,
      customer_id: d3Customer.customer_id,
      customer_order_count: d3Customer.customer_order_count,
      email: d3Customer.email,
      email_hashed: d3Customer.email_hashed,
      search_terms: d3Search.search_terms,
      search_result_count: d3Search.search_result_count,
      category_id: d3Collection.id,
      category_name: d3Collection.name,
      current_cart: { currency: null, value: 0.00, total_quantity: 0, items: [] }
    };
    
    if (d3Cart) {
      var gtmLineItems = mapCartLinesToGTMItems(d3Cart.items);
      gtmEvent.current_cart = {
        currency: d3Cart.currency,
        value: (d3Cart.total_price * 0.01),
        total_quantity: d3Cart.item_count,
        items: gtmLineItems    
      }
    }
  
    //window.console.log("view_page gtm data=", gtmEvent);
    window.dataLayer.push(gtmEvent);
  }
  
  /************ 
    send "view_cart" event to GTM 
  *************/
  function d3ViewCart() {
    //window.console.log("d3ViewCart");
    
    var gtmLineItems = mapCartLinesToGTMItems(d3Cart.items);
    
    var gtmEvent = {
      event: "view_cart",
      ecommerce: {
        currency: d3Cart.currency,
        value: (d3Cart.total_price * 0.01),
        total_quantity: d3Cart.item_count,
        items: gtmLineItems      
      }
    };
    //window.console.log("view_cart gtm data=", gtmEvent);
    window.dataLayer.push(gtmEvent);
  }
  
  /************ 
    send "cart_updated" event to GTM 
  *************/
  function d3CartUpdated() {
    //window.console.log("d3CartUpdated");
    
    // clear it first
    dataLayer.push({ current_cart: null });
    
    var gtmLineItems = mapCartLinesToGTMItems(d3Cart.items);
    
    var gtmEvent = {
      event: "cart_updated",
      current_cart: { // do not use ecommerce here
        currency: d3Cart.currency,
        value: (d3Cart.total_price * 0.01),
        total_quantity: d3Cart.item_count,
        items: gtmLineItems      
      }
    };
    //window.console.log("cart_updated gtm data=", gtmEvent);
    window.dataLayer.push(gtmEvent);
  }
  
  /************ 
    send "cart_empty" event to GTM 
    when the cart goes from 1 or more to Zero
  *************/
  function d3CartEmpty() {
    window.dataLayer.push({ event: "cart_empty" });
  }
  
  /************ 
    send PDP "view_item" event to GTM 
  *************/
  function d3ViewPDP() {
    var pdpGA4item = d3GetGA4Product(d3Product, d3Variant); 
    //window.console.log("d3ViewPDP", pdpGA4item);
    var gtmEvent = {
      event: "view_item_ecom", // cannot use view_item because it is being sent by the google/youtube app
      ecommerce: {
        currency: d3Cart.currency,
        value: pdpGA4item.price,
        items: [ pdpGA4item ]
      }
    };
    
    //window.console.log("view_item gtm data=", gtmEvent);
    window.dataLayer.push(gtmEvent);
  }
  
  /************ 
    send "add_to_cart" event to GTM from PDP
  *************/
  function d3AddToCartPDP(variantId, quantity, productId, sectionId) {
    var $wrapper = null;
    if (sectionId) {
      $wrapper = $(`[data-section-id="${sectionId}"]`);
    }
    if (!$wrapper.length) {
      $wrapper = $('.product-page--root');
    }    
    var productJson = d3Product;
    var variantJson = d3Variant;
    
    try {
      // pull from here to be compatible with custom MasterSku color picker
      var jsonElement = $wrapper.find('#product-mastersku--json');
      var allprods = JSON.parse(jsonElement.html());
      var foundProd = findParentProductByVariantId(allprods, variantId);              
      if (foundProd != null) {
        productJson = foundProd;
      }
    } catch(er) {
      window.console.log('error', er)
    }
  
    var allVariants = productJson.variants;
    try {
      // pull from here to be compatible with custom MasterSku color picker
      var jsonElement = $wrapper.find('[id*=variant--json]');
      allVariants = JSON.parse(jsonElement.html());
    } catch (ex) {}
      
    var variantObj = allVariants.find(v => v.id.toString() == variantId);
    if (!variantObj) {
      window.console.log('error finding variant for add to cart');
      return;
    }
  
    if (quantity == null || isNaN(quantity)) {
      quantity = 1;
    } else {
      quantity = parseInt(quantity);
    }
    
    var addedGA4item = d3GetGA4Product(productJson, variantObj); 
    addedGA4item.quantity = quantity;
    var gtmEvent = {
        event: 'add_to_cart_ecom', // cannot use add_to_cart because it is being sent by the google/youtube app
        ecommerce: {
          currencyCode: d3Cart.currency,
          items: [ addedGA4item ]
        }
    };
    //window.console.log('add_to_cart gtm data=', gtmEvent);
    window.dataLayer.push(gtmEvent);
  }
  
  /************ 
    send "add_to_cart" event to GTM from Quick Add
  *************/
  function d3AddToCartQuickAdd(variantId, quantity, productId) {
    var $productTiles = $('product-tile-root');
    var productJsonEl = $(`script.producttile--product-json[data-product-id="${productId}"]`);
    var productData, allVariants = [];
    try {
      productData = JSON.parse(
        productJsonEl.html()
      );    
      allVariants = productData.variants;
    } catch (ex) {}
    
    var variantData = allVariants.find(v => v.id.toString() == variantId);
    if (!variantData) {
      window.console.log('error finding variant for add to cart');
      return;
    }
    
    if (quantity == null || isNaN(quantity)) {
      quantity = 1;
    } else {
      quantity = parseInt(quantity);
    }
    
    var addedGA4item = d3GetGA4Product(productData, variantData);
    addedGA4item.quantity = quantity;
    var gtmEvent = {
        event: 'add_to_cart_ecom', // cannot use add_to_cart because it is being sent by the google/youtube app
        ecommerce: {
          currencyCode: d3Cart.currency,
          items: [ addedGA4item ]
        }
    };
    //window.console.log('add_to_cart gtm data=', gtmEvent);
    window.dataLayer.push(gtmEvent);
  }
  
  /************ 
    send "remove_from_cart" event to GTM 
  *************/
  function d3RemoveFromCart(removedLineItem) {
    var removedGA4item = d3GetGA4RemovedProductLineItem(removedLineItem);
    var gtmEvent = {
        event: 'remove_from_cart_ecom',
        ecommerce: {
          currencyCode: d3Cart.currency,
          items: [ removedGA4item ]
        }
    };
    window.console.log('remove_from_cart gtm data=', gtmEvent);
    window.dataLayer.push(gtmEvent);
  }
  
  /************ 
    send "view_item_list" events to GTM (when product tile enters viewport)
  *************/
  var d3ImpressionsManager = {
    maxCheck: 0,
    timer: null,
    queue: [],
    startListener: function() {
      window.on('theme:producttile:viewed', ({ detail: elements }) => {
          d3ImpressionsManager.queue.push(...elements);    
          if (d3jqueryLoaded) {
            setTimeout(() => {
              d3ImpressionsManager.timer.resume();
            }, 500);
          }  
      });
      
      this.timer = new ResumableInterval(() => {    
        d3ImpressionsManager.checkQueue();    
      }, 1000);
    },
    startTimer: function () {
      this.timer.start();
    },
    checkQueue: function(){ 
      if (this.queue.length == 0){
        this.maxCheck++;
        if (this.maxCheck > 12) {
          this.timer.pause();
        }
        return false; 
      } else { 
        this.maxCheck = 0;
        this.handleQueue(); 
      }
    },
    handleQueue: function () {
      var ga4Products = [];
      var localQueue = Array.from(this.queue);
      this.queue.splice(0, this.queue.length);
      for (var i = 0; i < localQueue.length; i++) {
        var element = localQueue[i];
        var $elem = $(element);
        var tileIndex = $elem.parent().children('product-tile-root').index($elem);
        var productData = JSON.parse(
          element.querySelector('script.producttile--product-json').innerHTML
        );
        var variantData = JSON.parse(
          element.querySelector('script.producttile--variant-json').innerHTML
        );
        var ga4item = d3GetGA4Product(productData, variantData);
        ga4item.index = tileIndex + 1;
        
        var $listcontainer = $elem.closest('[data-list-id]');
        if ($listcontainer.length) {
          ga4item.item_list_id = $listcontainer.data('list-id');
          ga4item.item_list_name = $listcontainer.data('list-name');
        }
        
        ga4Products.push(ga4item);
      }
      var gtmEvent = {
          "event": "view_item_list",
          "ecommerce": {  
              "items": ga4Products
          }
      };
      //window.console.log("view_item_list gtm data=", gtmEvent);
      window.dataLayer.push(gtmEvent);
    }
  };
  
  /************ 
    handle Customer registration
  *************/
  function d3OnCreateAccount() {
    var $form = $('#create_customer');
    if ($form.length) {
      $form.on('submit', function(e){
        var email = $('input[name="customer[email]"]').val();  
        var gtmEvent = {
          event: 'customer_registered',
          email: email
        };
        //window.console.log('customer_registered gtm data=', gtmEvent);
        window.dataLayer.push(gtmEvent);
      });
    }
  }
  
  /************ 
    handle klaviyo newsletter signup
  *************/
  function d3OnKlaviyoSubmit() {
      window.addEventListener("klaviyoForms", function(e) { 
          window.console.log('klaviyoForms event' , e);
          if (e.detail.type == 'submit') {
            if (e.detail.metaData && e.detail.metaData.$email) {
              var gtmEvent = {
                event: 'newsletter_signup',
                email: e.detail.metaData.$email,
                signup_source: e.detail.metaData.$source
              };
              window.console.log('klaviyo newsletter_signup gtm data=', gtmEvent);
              window.dataLayer.push(gtmEvent);
            }
          }
      });
  }
  
  /************ 
    handle Customer signup
  *************/
  function d3OnEmailSignup() {
    var $forms = $('form[action^="/contact"]');
    if ($forms.length) {
      $forms.on('submit', function(e){
        var $form = $(this);
        var formid = $form.attr('id');
        // make sure it's not the Contact Us form
        var is_signup_form = (formid == 'footer_form' || formid.indexOf('newsletter') > -1);
        if (is_signup_form) {
          var signup_source = (formid == 'footer_form') ? 'Footer' : 'Newsletter Signup';
          var email_input = $form.find('input[name="contact[email]"]');  
          if (email_input.length) {
            var email = email_input.val();
            var gtmEvent = {
              event: 'newsletter_signup',
              email: email,
              signup_source: signup_source
            };
            //window.console.log('newsletter_signup gtm data=', gtmEvent);
            window.dataLayer.push(gtmEvent);
          }
        }
      });
    }
  }
  
  /***
    d3GetGA4Product
    Map Shopify Product JSON object to GA4 object
   ***/
  function d3GetGA4Product(shopifyProduct, shopifyVariant) {
     //window.console.log('d3GetGA4Product', shopifyProduct, shopifyVariant);
  
    if (typeof shopifyVariant == 'undefined' || shopifyVariant == null) {
      shopifyVariant = shopifyProduct.variants[0];
    }
    
    var ga4item = {
      item_id: shopifyProduct.id.toString(),
      item_name: shopifyProduct.title,
      item_brand: shopifyProduct.vendor,
      item_category: shopifyProduct.type,
      item_variant: shopifyVariant.id.toString(),
      item_sku: shopifyVariant.sku != null ? shopifyVariant.sku.toString() : null,
      price: (shopifyVariant.price * 0.01),
      product_handle: shopifyProduct.handle,
      product_url: 'https://' + window.location.hostname + '/products/' + shopifyProduct.handle,
      product_image: 'https:' + shopifyProduct.featured_image
    }; 
    for (var j = 0; j < shopifyProduct.options.length; j++) {
      // adding item_color, item_size
      ga4item['item_'+shopifyProduct.options[j].toLowerCase()] = shopifyVariant.options[j].toString();
    }
    
    return ga4item;
  }
  
  /***
    d3GetGA4ProductLineItem
    Map Shopify Line Item Product JSON object to GA4 object
   ***/
  function d3GetGA4ProductLineItem(shopifyLineItem) {
    //window.console.log('d3GetGA4ProductLineItem', shopifyLineItem);
    var ga4item = {
      item_id: shopifyLineItem.product_id.toString(),
      item_name: shopifyLineItem.product_title,
      item_brand: shopifyLineItem.vendor,
      item_category: shopifyLineItem.product_type,
      item_variant: shopifyLineItem.variant_id.toString(),
      item_sku: shopifyLineItem.sku != null ? shopifyLineItem.sku.toString() : null,
      price: (shopifyLineItem.price * 0.01),
      quantity: shopifyLineItem.quantity,
      product_handle: shopifyLineItem.handle,
      product_url: 'https://' + window.location.hostname + '/products/' + shopifyLineItem.handle,
      product_image: 'https:' + shopifyLineItem.image
    }; 
    for (var j = 0; j < shopifyLineItem.options_with_values.length; j++) {
      // adding item_color, item_size
      ga4item['item_'+shopifyLineItem.options_with_values[j].name.toLowerCase()] = shopifyLineItem.options_with_values[j].value.toString();
    }
    return ga4item;
  }
  
  /***
    d3GetGA4RemovedProductLineItem
    Map Shopify Removed Line Item Product JSON object to GA4 object
   ***/
  function d3GetGA4RemovedProductLineItem(shopifyLineItem) {
    //window.console.log('d3GetGA4RemovedProductLineItem', shopifyLineItem);
    var ga4item = {
      item_id: shopifyLineItem.product_id.toString(),
      item_name: shopifyLineItem.title,
      item_brand: shopifyLineItem.vendor,
      item_category: shopifyLineItem.product_type,
      item_variant: shopifyLineItem.variant_id.toString(),
      item_sku: shopifyLineItem.sku != null ? shopifyLineItem.sku.toString() : null,
      price: parseFloat(shopifyLineItem.price),
      quantity: shopifyLineItem.quantity,
      product_handle: null,
      product_url: null,
      product_image: shopifyLineItem.image,
      item_color: null,
      item_size: null
    };
    return ga4item;
  }
  
  /************
    custom function to map array of shopify cart lineItems to GTM dataLayer lineItems
  *************/
  function mapCartLinesToGTMItems(shopifylineItems) {
    let gtmLineItems = [];
    for (var i = 0; i < shopifylineItems.length; i++) {
      var lineItem = shopifylineItems[i];
      var gtmItem = d3GetGA4ProductLineItem(lineItem);
      gtmItem.index = i+1;
      gtmLineItems.push(gtmItem);
    }  
    return gtmLineItems;
  }
  
  /***
    findParentProductByVariantId
    search through an array of products and their variants to return the parent product
   ***/
  function findParentProductByVariantId(productsArray, variantId) {
    var foundProd = null;
    for (var x = 0; x < productsArray.length; x++) {
        var loopprod = productsArray[x];
        for (var j = 0; j < loopprod.variants.length; j++) {
          var loopvariant = loopprod.variants[j];
          if (loopvariant.id.toString() == variantId.toString()) {
            foundProd = loopprod;
            break;
          }
        }
        if (foundProd != null) {
          break;
        }
    }
    return foundProd;    
  }
  
  /* do not modify */
  if (/complete|interactive|loaded/.test(document.readyState)) {
      d3DomLoaded();
  } else {
      document.addEventListener('DOMContentLoaded', d3DomLoaded);
  }